import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "./redux/home/homeSlice";
import nsoFlowSlice from "./redux/nsoFlow/nsoFlowSlice";
import simFlowSlice from "./redux/simFlow/simFlowSlice";
import authSlice from "./redux/auth/authSlice";
import errorStepSlice from "./redux/errorStep/errorStepSlice";
import tokenExpirationMiddleware from "utils/middlewares/tokenExpirationMiddleware";
import configPanelSlice from "./redux/configPanel/configPanelSlice";
export const store: any = configureStore({
  reducer: {
    home: homeSlice,
    nsoFlow: nsoFlowSlice,
    simFlow: simFlowSlice,
    auth: authSlice,
    errorStep: errorStepSlice,
    configPanel: configPanelSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // }),
    }).concat(tokenExpirationMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
